import { render, staticRenderFns } from "./DocumentListField.vue?vue&type=template&id=2a24b6d3&scoped=true&"
import script from "./DocumentListField.vue?vue&type=script&lang=ts&"
export * from "./DocumentListField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24b6d3",
  null
  
)

export default component.exports